module.exports = __webpack_public_path__ + "img/logo-z.f50c69a0.png";